import React from "react";
import ResultAbout from "../ResultChart/ResultAbout";
import './LeftTExt.css';
import { formatDecimal } from "../../helpers/utils";

function formatNumber(num) {
    if (num % 1 !== 0) {
        return formatDecimal(num);
    } else {
        return parseInt(num);
    }
}

function LeftTextRadius({ data }) {
    return (
        <div className="left-text-radius">
            <div className="about_g text-white">
                <ResultAbout title={"Stenosis length"} about={formatNumber(data.stenosis.length) + " mm"} />
                <ResultAbout title={"Lumen diameter"} about={formatNumber(data.stenosis.lumen) + " mm"} />
                <ResultAbout title={"Stenosis diameter"} about={Math.round(data.stenosis.D) + " %"} />
                <ResultAbout title={"Stenosis area"} about={Math.round(data.stenosis.A) + " %"} />
            </div>
        </div>
    );
}

export default LeftTextRadius;